import { useContext } from 'react'
import { DataContext, type DataContextValue } from './dataContextCore'

export const useData = (): DataContextValue => {
  const context = useContext(DataContext)

  if (!context) {
    throw new Error('useData must be used within a DataProvider.')
  }

  return context
}
